<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">16</h2>
<p class="vers"><span>Ich habe</span> die Ladung
gehabt zum<br class="calibre1"/>
Fest dieser Welt, und so ist mein Leben<br class="calibre1"/>
gesegnet. Meine Augen haben gesehn,<br class="calibre1"/>
meine Ohren gehört.</p>
<p class="vers">Mein Teil auf diesem Feste war, mein<br class="calibre1"/>
Instrument zu spielen, ich habe alles,<br class="calibre1"/>
was ich konnte, getan.</p>
<p class="vers">Nun frag ich, ist endlich die Zeit mir<br class="calibre1"/>
gekommen, wo ich eintreten darf und<br class="calibre1"/>
dein Antlitz sehn und dir schweigend<br class="calibre1"/>
bieten meinen Gruß? <a id="page21" title="Wunibald/cal"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0017.vue?6ede863f